import React from 'react';
import {useTranslation} from "react-i18next";

export const Forbidden = () => {

    const {t} = useTranslation(['common'])

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>{t("forbidden")}</h5>
                    <p>{t("forbidden.detail")}.</p>
                </div>
            </div>
        </div>
    );
}
